import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import FloatingActionButton from "./FloatingActionButton";
import VersaoBuild from "./VersaoBuild";
import { useAuth } from "../context/AuthContext";
import { menuItemPorRota } from "../config/menuItems";

const Template = ({ children }) => {
  const { empresa } = useAuth();
  const location = useLocation();

  // Título da aba com a empresa na frente.
  //
  // O index.html trazia "DAFMC" fixo. Com duas empresas abertas em abas
  // diferentes — que é justamente quando o engano custa caro — as abas ficavam
  // idênticas e não havia como saber em qual delas se estava lançando.
  useEffect(() => {
    const tela = menuItemPorRota(location.pathname)?.name;
    const partes = [empresa?.nome, tela].filter(Boolean);
    document.title = partes.length ? partes.join(" · ") : "Gestão de Licitação";
  }, [empresa, location.pathname]);

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar fixa no lado esquerdo */}
      <Sidebar />

      {/* Área Principal */}
      <div className="flex flex-col flex-1 bg-gray-50 overflow-auto">
        {/* Header no topo */}
        <Header />

        {/* Área principal para renderizar os children */}
        <main className="flex-1 p-2 sm:p-6 bg-gray-50">{children}</main>

        {/* Identificação da build publicada */}
        <VersaoBuild />
      </div>

      {/* Botão Flutuante Global */}
      <FloatingActionButton />
    </div>
  );
};

export default Template;
